import { format } from 'date-fns';

export default function GetFileName(name, type) {
    return `${format(new Date(), `'${name}-'yyyy-MM-dd-HH-mm-ss`)}.${type}`;
}
